/*
 * Size help under the size buttons (snippets/product-size-help.liquid).
 *
 * Shows the block once the visitor, on the same product and in this browser
 * session, switched size twice (from one size to another) or opened the size
 * chart twice. Counted in sessionStorage per product, so a reload or a second
 * visit in the same session keeps the count; once shown it stays shown there.
 * The block appears right after the visitor's own click, so it does not count
 * as a layout shift.
 *
 * Measured with the Cortex pixel: SizeHelpShown once per product per session
 * ({ productId, reason: 'switches' | 'chart' }).
 */
(() => {
  if (window.JapSizeHelp) return;
  window.JapSizeHelp = true;

  const NEEDED = 2;
  const keyFor = (productId) => `jc-maattwijfel-${productId}`;
  const fresh = () => ({ switches: 0, opens: 0, shown: false });

  function read(productId) {
    try {
      return JSON.parse(sessionStorage.getItem(keyFor(productId)) || 'null') || fresh();
    } catch (error) {
      return fresh();
    }
  }

  function write(productId, count) {
    try {
      sessionStorage.setItem(keyFor(productId), JSON.stringify(count));
    } catch (error) {
      // No storage: the count lasts as long as this page.
    }
  }

  function track(name, data) {
    const payload = { ...data, source: 'theme' };
    if (window.NanoPixel) {
      window.NanoPixel.track(name, payload);
    } else {
      window.NanoPixelQueue = window.NanoPixelQueue || [];
      window.NanoPixelQueue.push([name, payload]);
    }
  }

  document.querySelectorAll('[data-size-help]').forEach((block) => {
    const { productId } = block.dataset;
    const root = block.closest('.shopify-section') || document;
    // The size buttons: the option group that carries the size chart button.
    const sizes = [...root.querySelectorAll('fieldset.option-selector')].find((group) =>
      group.querySelector('[data-modal="size-chart"]')
    );
    const count = read(productId);

    function show(reason) {
      block.hidden = false;
      if (count.shown) return;
      count.shown = true;
      write(productId, count);
      track('SizeHelpShown', { productId, reason });
    }

    function note(field) {
      count[field] += 1;
      write(productId, count);
      if (count[field] >= NEEDED) show(field === 'opens' ? 'chart' : 'switches');
    }

    if (count.shown) block.hidden = false;

    if (sizes) {
      let current = sizes.querySelector('input:checked')?.value ?? null;
      sizes.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.checked) return;
        if (current !== null && input.value !== current) note('switches');
        current = input.value;
      });
    }

    // Opening the size chart from any button of this product, except the one in the block itself.
    root.addEventListener(
      'click',
      (event) => {
        const opener = event.target.closest('modal-opener[data-modal="size-chart"]');
        if (opener && !block.contains(opener)) note('opens');
      },
      true
    );
  });
})();
